import { ReactElement } from 'react'

import Markdown from 'markdown-to-jsx'
import { useTheme } from 'styled-components'

import { FileUpload } from '@Components'
import { Box, Tag } from '@corabank/arco'
import { useDocs } from '@Store'

import { DOCS_FORM } from './constants'
import * as Styled from './styles'

const LinkComponent = ({ children, ...props }: { children: ReactElement }) => (
  <a {...props}>{children}</a>
)

const DocsForm = () => {
  const {
    businessRegistrationTexts,
    maxFilesMessage,
    maxSizeMessage,
    rejectMessage,
    setSuccess,
    updateRegistrationDocs,
  } = useDocs()
  const { colors } = useTheme()

  const handleChange = (files: File[] | undefined, index: number) => {
    setSuccess(DOCS_FORM.SUCCESS_MESSAGE.ATTACHED_DOC)
    mixpanel.track(DOCS_FORM.SUCCESS_MESSAGE.ATTACHED_DOC_METRIC)
    updateRegistrationDocs(files || [], index)
  }

  const handleRemoveFile = (files: File[], index: number) => {
    setSuccess(DOCS_FORM.SUCCESS_MESSAGE.REMOVED_DOC)
    mixpanel.track(DOCS_FORM.SUCCESS_MESSAGE.REMOVED_DOC_METRIC)
    updateRegistrationDocs(files, index)
  }

  return (
    <Box>
      {businessRegistrationTexts?.map((item, index) => (
        <Box
          key={`card-${index}`}
          border={`1px solid ${colors.graysGray3}`}
          borderRadius="16px"
          mb="24px"
          p="24px"
        >
          <Tag variant="alert" label="Ação pendente" />

          <Styled.DocsFormTitle variant="body1" weight="bold">
            {item?.title}
          </Styled.DocsFormTitle>

          {item?.description && (
            <Styled.DocsFormTexts tag="div" variant="body2" color="graysGray1">
              <Markdown
                options={{
                  forceBlock: true,
                  overrides: {
                    a: {
                      component: LinkComponent,
                      props: {
                        target: '_blank',
                      },
                    },
                  },
                }}
              >
                {item?.description}
              </Markdown>
            </Styled.DocsFormTexts>
          )}

          <FileUpload
            multiple
            name="doc-qsa-upload"
            onChange={(files) => handleChange(files, index)}
            onRemoveFile={(files) => handleRemoveFile(files, index)}
            maxSize={31457280}
            onMaxSize={maxSizeMessage}
            maxFiles={3}
            onMaxFiles={maxFilesMessage}
            onReject={rejectMessage}
            accept={{
              'image/png': ['.jpg', '.jpeg', '.png'],
              'application/pdf': ['.pdf'],
            }}
          />
        </Box>
      ))}
    </Box>
  )
}

export { DocsForm }
